import { hasInjectionContext } from 'vue'
import { useQueryClient } from '@tanstack/vue-query'
import type { QueryClient } from '@tanstack/vue-query'

// Returns the Vue Query client only when an injection context is available —
// a component setup, or a Pinia store first instantiated from one. Pinia setup
// stores can also be constructed outside an app context (unit tests using a bare
// createPinia(), early route middleware), where calling useQueryClient() directly
// throws "vue-query hooks can only be used inside setup()". Call sites should
// optional-chain the result so invalidation is a no-op in those contexts.
export function useOptionalQueryClient(): QueryClient | undefined {
  return hasInjectionContext() ? useQueryClient() : undefined
}
